import React from "react";
import { BrowseUsersPageContent } from "gui/browse-users/browse-users";
import { GetStaticProps } from "next";
import { Header } from "shared/Header/Header";
import { PageHead } from "gui/head/head";
import { PageMain } from "gui/page/page";

interface Props {
  preview: boolean;
}

export const BrowseUsersPage: React.FC<Props> = (props) => {
  return (
    <>
      <PageHead title="Wizards" preview={props.preview} />
      <Header />
      <PageMain size="lg">
        <BrowseUsersPageContent />
      </PageMain>
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async (ctx) => {
  const props: Props = {
    preview: Boolean(ctx.preview),
  };

  return {
    props,
    revalidate: 10,
  };
};

export default BrowseUsersPage;
